import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export type DatenabrufEintrag = {
  name: string;
  anzeigename: string;
  gewaehlt: number;
  gesamt: number;
};

export function DatenabrufListe({
  datenabruf,
}: {
  datenabruf: DatenabrufEintrag[];
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      {datenabruf.map((endpunkt) => (
        <div key={endpunkt.name} className="flex items-center gap-4">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutrals-200">
            <FontAwesomeIcon
              icon={faDatabase}
              className="text-primary-blue-600"
            />
          </span>
          <div>
            <p className="text-sm font-semibold text-neutrals-900">
              {endpunkt.anzeigename}
            </p>
            <p className="text-xs text-neutrals-700">
              {t('domain.e2nApi.karte.attribute', {
                gewaehlt: endpunkt.gewaehlt,
                gesamt: endpunkt.gesamt,
              })}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
